/**
 * action types
 */
export const SET_INSTITUTION_DATA = 'SET_INSTITUTION_DATA';
export const SET_QUALIFICATION_DATA = 'SET_QUALIFICATION_DATA';
export const SET_COURSE_DATA = 'SET_COURSE_DATA';
export const QUALIFICATION_ENROLMENT_START = 'QUALIFICATION_ENROLMENT_START';
export const QUALIFICATION_ENROLMENT_SUCCESS =
  'QUALIFICATION_ENROLMENT_SUCCESS';
export const QUALIFICATION_ENROLMENT_FAILURE =
  'QUALIFICATION_ENROLMENT_FAILURE';
export const QUALIFICATION_EXTERNAL_ENROLMENT_START =
  'QUALIFICATION_EXTERNAL_ENROLMENT_START';
export const SET_INSTITUTION_CATEGORY_COURSES_DATA =
  'SET_INSTITUTION_CATEGORY_COURSES_DATA';
export const SET_INSTITUTION_YOUR_COURSES_DATA =
  'SET_INSTITUTION_YOUR_COURSES_DATA';
